module.exports = __webpack_public_path__ + "img/UNIVERSAL P340.02200032.png";